// Вычисляет расстояние между двумя географическими точками по широте и долготе
export const getDistanceFromLatLon = (
  lat1: number, // Широта первой точки
  lon1: number, // Долгота первой точки
  lat2: number, // Широта второй точки
  lon2: number // Долгота второй точки
) => {
  const EARTH_RADIUS = 6371000 // Радиус Земли в метрах

  // Переводим разницу широты и долготы из градусов в радианы
  const deltaLat = degreesToRadians(lat2 - lat1)
  const deltaLon = degreesToRadians(lon2 - lon1)

  // Вычисляем угловое расстояние между точками с помощью формулы Гаверсинуса
  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(degreesToRadians(lat1)) *
      Math.cos(degreesToRadians(lat2)) *
      Math.sin(deltaLon / 2) *
      Math.sin(deltaLon / 2)

  // Вычисляем центральный угол (угол между точками на поверхности сферы)
  const centralAngle = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  // Вычисляем расстояние между точками на поверхности Земли
  const distance = EARTH_RADIUS * centralAngle // Расстояние в метрах
  return distance
}

// Функция для перевода градусов в радианы
export const degreesToRadians = (degrees: number) => {
  return degrees * (Math.PI / 180)
}
